import { render } from "./TipoExamen_Examen.vue?vue&type=template&id=f65e9028"
import script from "./TipoExamen_Examen.vue?vue&type=script&lang=js"
export * from "./TipoExamen_Examen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__